// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikInputNumber } from "src/components/Forms/TextInputNumber";
import { Typography } from "src/components/Core/Typography";
import { Row, Col } from "antd";

interface Props {
  errors: any;
}

const WatchTime: React.FC<Props> = ({ errors }) => {
  return (
    <Field label="Watch time" mb={26}>
      <Row gutter={16}>
        <Col span={12}>
          <Typography size={14} color="grey7">
            Mins
          </Typography>
          <FormikInputNumber
            parser={value => {
              let parsed = value.replace(/\[0-9]/g, "");
              if (parsed) {
                return parsed.match(/\d+/g) ? parseInt(parsed) : "";
              } else {
                return null;
              }
            }}
            name="watchTimeMinutes"
            size="middle"
            borderRadius={3}
            borderColor="grey8"
            placeholder="Mins"
            shouldShowError={false}
          />
        </Col>
        <Col span={12}>
          <Typography size={14} color="grey7">
            Secs
          </Typography>
          <FormikInputNumber
            parser={value => {
              let parsed = value.replace(/\[0-9]/g, "");
              if (parsed) {
                return parsed.match(/\d+/g) ? parseInt(parsed) : "";
              } else {
                return null;
              }
            }}
            name="watchTimeSeconds"
            size="middle"
            borderRadius={3}
            borderColor="grey8"
            placeholder="Secs"
            shouldShowError={false}
          />
        </Col>
      </Row>
      <Typography size={14} color="grey7" mb={0}>
        How much of your video are users watching
      </Typography>
      {(errors?.watchTimeMinutes || errors?.watchTimeSeconds) && (
        <Typography size={14} color="red" mt="5px">
          Please enter watch time
        </Typography>
      )}
    </Field>
  );
};

export default WatchTime;
